import { useMutation, useQueryClient } from '@tanstack/react-query';
import { revokePartnerAccess } from '../services/partners';
import { partnerQueryKeys } from './query-keys';

export const useRevokePartnerMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ partnerId, email, removeWholePartner }) => {
      const result = await revokePartnerAccess({ partnerId, email, removeWholePartner });
      if (!result.success) {
        throw new Error(result.message || 'Failed to remove partner access');
      }
      return result;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: partnerQueryKeys.all });
      options.onSuccess?.(...args);
    },
    ...options,
  });
};
